import { httpClient } from '@/services/http/httpClient'

export const archivePortfolioProject = async (projectId: string) => {
  await httpClient.put(`/projects/portfolio-projects/${projectId}/archive`)
}
